import React from "react";
import ImageGallery, { ReactImageGalleryItem } from "react-image-gallery";

interface Product {
  __typename: string;
  attributes: {
    __typename: string;
    url: string;
    formats: {
      thumbnail: {
        ext: string;
        url: string;
        hash: string;
        mime: string;
        name: string;
        path: string | null;
        size: number;
        width: number;
        height: number;
        provider_metadata: {
          fileId: string;
        };
      };
    };
  };
  image: {
    url: string;
    name: string;
    bigCardThumbnailUrl: string;
    smallCardThumbnailMobileUrl: string;
    smallCardThumbnailUrl: string;
    smallProductThumbnailUrl: string;
    bigProductThumbCard: string;
  };
}

export const Gallery = ({ products = [], styleClass }) => {
  const images = products.map((product: Product) => {
    return {
      original: product?.attributes?.url,
      thumbnail:
        product?.image?.smallProductThumbnailUrl || product?.attributes?.formats?.thumbnail?.url,
    };
  });

  return (
    <div className={styleClass}>
      <ImageGallery
        disableThumbnailScroll={false}
        showPlayButton={false}
        showFullscreenButton={false}
        thumbnailPosition={"bottom"}
        items={images as ReadonlyArray<ReactImageGalleryItem>}
      />
    </div>
  );
};
